import { useNavigate, useParams } from "react-router-dom"
import ModalFeedBack from "../../../../components/ModalFeedBack"
import { excluirComunicado } from "../../../../services/ComunicadoService"
import { useState } from "react"
import LoadingApp from "../../../../components/LoadingApp"

interface ModalAgendamentoTerminadoProps {
    showModal: boolean
    subTitle: string
}

const ModalAgendamentoTerminado: React.FC<ModalAgendamentoTerminadoProps> = ({ showModal, subTitle }) => {
    const navigate = useNavigate()
    const { idComunic } = useParams();
    const [loading, setLoading] = useState<boolean>(false);

    const handleShowModal = () => {
        if (idComunic) {
            setLoading(true)
            excluirComunicado(idComunic, 'S').then(() => {
                navigate('/notificacoes/notificacao')
            }).finally(() => setLoading(false))
        }
    }

    return (
        <>
            <ModalFeedBack
                showModal={showModal}
                title="Atenção"
                icon="warning"
                textButton="Fechar"
                showButtonModal={true}
                classNameModal="modal-custom"
                subTitle={subTitle}
                handleButtonModal={handleShowModal}
                handleShowModal={handleShowModal}
            />
            <LoadingApp showLoading={loading} />
        </>
    )
}

export default ModalAgendamentoTerminado